$(document).ready(function() {
  
  /* RP change 3-13-2025 */
  // Check if the current page is not the homepage
  if (window.location.pathname !== '/') {
    // Select header and menu elements
    const $header = $('header');
    const $menu = $('.header__inline-menu');
  
    // Apply CSS styles in header and its menu
    if ($header.length) {
      $header.css('box-shadow', '0px 4px 4px 0px rgba(175, 175, 175, 0.05)');
    }

    if ($menu.length) {
      $menu.css('margin-bottom', '44px');
    }
  }

  /* RP change 3-17-2025 */
  const urlParams = new URLSearchParams(window.location.search);
  const sectionValue = urlParams.get('section');

  // Redirect and scroll to the target section if on the specific page and hash matches
  if (window.location.pathname === '/pages/our-story-1' && sectionValue === 'our-brewery') {
    const $target = $('#our-brewery');

    if ($target.length) {

      // Get screen current width
      let screenWidth = $(window).outerWidth();

      // Get the top position of the target section and adjust the scroll position
      let offsetTop = $target.offset().top;

      // Adjust offsetTop based on screen size
      if(screenWidth >= 990) {
          offsetTop = offsetTop - 207;
      }
      else if(screenWidth >= 750) {
          /* RP change 4-11-2025 */
          offsetTop = offsetTop - 127;
      }
      else if(screenWidth === 749) {
          offsetTop = offsetTop - 50;
      }
      
      // Adjust scroll position with the desired offset (e.g., 700px)
      $('html, body').animate({
        scrollTop: offsetTop // Adjust by the desired number of pixels
      }, 'smooth');
    }
  }

  /* RP change 4-04-2025 */
  // For turning add to cart and buy buttons into enabled or disabled if iagree-checkbox is checked or not (connected to .product-form__submit, .shopify-payment-button css in assets/base.css )
  $(document).on('click', ".iagree-checkbox", function() {

    // Get id of the form
    var id = $(this).attr('form');
    
    if ($(this).prop('checked')) {
        $(`#${id} .product-form__submit.button.button--secondary.button--full-width, #${id} .shopify-payment-button, #${id} .product-form__submit.button.button--small`).css({
          'pointer-events': 'auto',  // Allow interactions with the button
          'opacity': '1',            // Restore full opacity
          'cursor': 'pointer'        // Restore to default pointer
        });
     }
     else {
        $(`#${id} .product-form__submit.button.button--secondary.button--full-width, #${id} .shopify-payment-button, #${id} .product-form__submit.button.button--small`).css({
          'pointer-events': 'none',   // Prevent interactions with the button
          'opacity': '0.5',           // Reduce opacity to show it's disabled
          'cursor': 'not-allowed'     // Change the cursor to indicate the button is disabled
        });
    }
  });

  // Sticky Cart
  $(document).on('click', ".iagree-checkbox-small", function() {

    // Get id of the form
    var id = $(this).attr('form');
    
    if ($(this).prop('checked')) {
        $(`#${id} .product-form__submit.button.button--small`).css({
          'pointer-events': 'auto',  // Allow interactions with the button
          'opacity': '1',            // Restore full opacity
          'cursor': 'pointer'        // Restore to default pointer
        });
     }
     else {
        $(`#${id} .product-form__submit.button.button--small`).css({
          'pointer-events': 'none',   // Prevent interactions with the button
          'opacity': '0.5',           // Reduce opacity to show it's disabled
          'cursor': 'not-allowed'     // Change the cursor to indicate the button is disabled
        });
    }
  });

  /* RP change 4-23-2025 */
  // For changing ShopifyChat plugin's title for tooltip
  let shopifyChatInterval = setInterval(function() {
      $('#ShopifyChat').attr('title', 'Crazy Carabao store chat');

      // $('#ShopifyChat').css('margin-bottom', '50px');
  
      if ($('#ShopifyChat').attr('title') === 'Crazy Carabao store chat') {
         // repositionChatLogo()
         // $('#shopify-chat').show();
        clearInterval(shopifyChatInterval)
      }
  }, 1000);


  // $(window).on('scroll resize', function() {
  //   if (mobileDock) {
  //   observer.observe(mobileDock);
  // }
    
  // });

  // function is_mobile_screen() {
  //   var window_outer_width = $(window).outerWidth();
  //   if (window_outer_width <= 750) {
  //     return true;
  //   }
  //   else {
  //     return false;
  //   }
  // }

  // const mobileDock = document.querySelector('mobile-dock');

  // const observer = new IntersectionObserver(entries => {
  //   entries.forEach(entry => {
  //     if (is_mobile_screen() == false) {
  //        $('#ShopifyChat').addClass('hidden-mobile-dock');
  //       return;
  //     }
  //  // alert( entry); // helps debu
  //     if (entry.isIntersecting) {
     
  //       $('#ShopifyChat').removeClass('hidden-mobile-dock');
  //     }
  //     else{
        
  //       $('#ShopifyChat').addClass('hidden-mobile-dock');
  //     }
  //   });
  // }, {
  //   threshold: 0.1 // Adjust based on how much needs to be visible
  // });
  
  // if (mobileDock) {
  //   observer.observe(mobileDock);
  // }

  

});